import React, { useState } from "react";
import PropTypes from "prop-types";

export default function Navbar1(props) {
  return (
    <div>
      <nav
        className={`navbar navbar-${props.modeText} bg-${props.modeText} navbar-expand-lg`}
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            {props.title}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`form-check form-switch form-check-reverse text-${
              props.modeText === "light" ? "Dark" : "light"
            }`}
          >
            <label className="form-check-label" htmlFor="flexSwitchCheckReverse">
              {props.modeText === "light" ? "Dark" : "Light"} Mode Enabled
            </label>
            <input
              className="form-check-input"
              type="checkbox"
              id="flexSwitchCheckReverse"
              onClick={props.changeModefxn}
            />
          </div>
        </div>
      </nav>
    </div>
  );
}

Navbar1.propTypes = { title: PropTypes.string.isRequired };
Navbar1.defaultProps = {
  title: "PlayvdText",
};
